import { connect } from 'react-redux';

import { getIsHotelOnly, getIsMobile } from 'src/store/view/selectors';
import {
  getInsurancePrice,
  getSelectedFlightData,
} from '../../store/selectors/order';

import { getCancellationPolicy } from '../../store/selectors/package';

import CancellationPolicyContainer from './CancellationPolicy';

const mapStateToProps = (state) => ({
  flightData: getSelectedFlightData(state),
  isMobile: getIsMobile(state),
  ensurancePrice: getInsurancePrice(state),
  cancellationPolicy: getCancellationPolicy(state),
  isHotelOnly: getIsHotelOnly(state),
});

export default connect(mapStateToProps)(CancellationPolicyContainer);
